import { Link, useLocation } from 'react-router-dom';
import useFetch from '../hooks/useFetch';
import { getSiteSettings, getContentPages } from '../services/api';
import SocialLinks from './SocialIcons';
import HashLink from './HashLink';

const FALLBACK_CONTACT = {
  email: 'info@nationwholesalellc.com',
  phone: '(213) 874-8192',
  hours: 'Mon–Fri: 9 AM – 6 PM EST',
  address: 'USA',
};

function Footer() {
  const { data: settings } = useFetch(() => getSiteSettings(), []);
  const contact = settings?.contact || FALLBACK_CONTACT;
  const socials = Array.isArray(settings?.socials) ? settings.socials : [];
  // CMS pages, each tagged with the footer column to list it under.
  const { data: pages } = useFetch(() => getContentPages(), []);
  const location = useLocation();

  // Group page links by the footer column the admin chose for each page.
  const pagesByColumn = (column) =>
    (pages || [])
      .filter((p) => p.footer_column === column)
      .sort((a, b) => (a.display_order || 0) - (b.display_order || 0));
  const companyPages = pagesByColumn('Company');
  const supportPages = pagesByColumn('Support');

  // On product pages, hide the Company + Support link columns.
  const isProductsPage = location.pathname.startsWith('/products');

  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className={`footer-grid${isProductsPage ? ' footer-grid--minimal' : ''}`}>
        {!isProductsPage && (
          <div className="footer-col">
            <h4>Company</h4>
            <HashLink hash="#services">Services</HashLink>
            <Link to="/products">Products</Link>
            <HashLink hash="#how">How It Works</HashLink>
            {companyPages.map((page) => (
              <Link key={page.id} to={`/${page.slug}`}>{page.title}</Link>
            ))}
          </div>
        )}

        {!isProductsPage && (
          <div className="footer-col">
            <h4>Support</h4>
            <HashLink hash="#faq">FAQ</HashLink>
            <Link to="/contact">Contact Us</Link>
            {supportPages.map((page) => (
              <Link key={page.id} to={`/${page.slug}`}>{page.title}</Link>
            ))}
          </div>
        )}

        <div className="footer-col">
          <h4>Contact</h4>
          {contact.email && (
            <a href={`mailto:${contact.email}`}>{contact.email}</a>
          )}
          {contact.phone && (
            <a href={`tel:${contact.phone.replace(/\D/g, '')}`}>{contact.phone}</a>
          )}
          {contact.hours && <p>{contact.hours}</p>}
        </div>

        <div className="footer-brand">
          <Link to="/" className="nav-logo">
            <img
              src={`${process.env.PUBLIC_URL}/nation-logo.svg`}
              alt="Nation Wholesale LLC"
              className="nav-logo-img"
            />
            <span className="nav-logo-text">
              NATION <span>WHOLESALE</span>
            </span>
          </Link>
          {contact.description && <p>{contact.description}</p>}
          {(contact.address || FALLBACK_CONTACT.address) && (
            <p>📍 {contact.address || FALLBACK_CONTACT.address}</p>
          )}
          <SocialLinks links={socials} />
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {currentYear} Nation Wholesale LLC. All rights reserved.</span>
        <span>Wholesale Distributors USA | Amazon FBA Supplier</span>
      </div>
    </footer>
  );
}

export default Footer;
